import { focus } from "common";
import { Accessor, Setter, createSignal } from "solid-js";
import { SetStoreFunction, Store, createStore } from "solid-js/store";
import { OrgYearInfo, focus as api } from 'st-app/api'

const focusKeyOrgs: Record<string, OrgYearInfo> = {};

export class FocusContext extends focus.FocusContextBase {
    orgYears: Store<OrgYearInfo[]>;
    private setOrgYears: SetStoreFunction<OrgYearInfo[]>;
    focusOrgYear: Accessor<OrgYearInfo | undefined>;
    private setFocusOrgYear: Setter<OrgYearInfo | undefined>;

    constructor() {
        super();

        [this.orgYears, this.setOrgYears] = createStore<OrgYearInfo[]>([]);
        [this.focusOrgYear, this.setFocusOrgYear] = createSignal<OrgYearInfo>();

        api.GetFocusInfo().then(res => {
            if (res.focusKey) {
                this.setFocusOrgYear(res.orgYears.find(oy => oy.orgYearGU === res.focusOrgYearGU));

                const focusOY = this.focusOrgYear();
                if (focusOY) {
                    focusKeyOrgs[res.focusKey] = focusOY;
                }
            }

            this.setFocusKey(res.focusKey ?? '');
            this.setOrgYears(res.orgYears);
        });
    }
}
